















































import Vue from "vue";
export default Vue.extend({
  methods: {
    async logout() {
      try {
        await (this as any).$dep.authUseCase.logout();
        this.$router.push({ name: "AuthLoginPage" });
      } catch (error) {
        console.log(error);
      }
    }
  }
});
